import React from 'react';
import './App.css';
import Products from './components/ProductsPage/ProductsPage'
import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/footer'

function App() {
  return (
    <div className="App">
      <Navbar />
      <Products />
      <Footer />
    </div>
  );
}

export default App;
